import type { Node } from 'prosemirror-model';

import FeatureGates from '@atlaskit/feature-gate-js-client';

import {
	EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS,
	EDITOR_HEADING_LINKS_EXPERIMENT_NAME,
} from './headingLinksConstants';
import { getHeadingIdForNode } from './headingLinksFromElements';

export const getIsHeadingLinksEnabled = (fireExperimentExposure: boolean): boolean => {
	const cohort = FeatureGates.getExperimentValue<EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS>(
		EDITOR_HEADING_LINKS_EXPERIMENT_NAME,
		'cohort',
		EDITOR_HEADING_LINKS_EXPERIMENT_COHORTS.NOT_ENROLLED,
		{ fireExperimentExposure },
	);

	return cohort === 'variant';
};

export const copyLink = async (node: Node): Promise<boolean> => {
	try {
		const headingId = getHeadingIdForNode(node);
		if (!headingId) {
			return false;
		}
		const url = new URL(location.href);
		url.hash = encodeURIComponent(headingId);
		const href = url.toString();

		if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
			await navigator.clipboard.writeText(href);
			return true;
		}

		return false;
	} catch {
		return false;
	}
};
